/**
 *
 * Asynchronously loads the component for NewWorkout
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
